<template>
  <div class="main">

    <!-- ToolBar -->
    <v-toolbar light dense color="transparent">
      <v-btn active-class icon light to="/">
        <v-icon color="grey darken-2">arrow_back</v-icon>
      </v-btn>
      <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->
      <!-- Add an avatar image here to the left of the TK name -->
      <v-toolbar-title></v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-btn icon><v-icon>search</v-icon></v-btn> -->
      <!-- <v-btn active-class icon v-on:click="goHome"><v-icon>fa fa-home</v-icon></v-btn> -->
      <v-btn active-class icon to="/tkbios"><v-icon>fa fa-paw</v-icon></v-btn>
      <v-btn active-class icon to="/"><v-icon>fa fa-home</v-icon></v-btn>
    </v-toolbar>

    <v-container fluid class="mainlogo">
      <v-layout column wrap align-center>
        <v-flex xs12>
          TKWEBDEV23
       </v-flex>
      </v-layout>
    </v-container>

  </div>
</template>

<script>
/* eslint-disable */
import TkHeaderView from './TkHeaderView'

export default {
  components: {
    TkHeaderView,
  },
  data: () => ({
  }),
  methods: {
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/TkWebDev23.vue